// @flow

import * as React from 'react';
import classnames from 'classnames';

import styles from './styles.scss';
import type { AttributeType, ItemType } from '../../api/types';
import { animateMatrix } from '../../utils/animation';
import StudioNav from './Nav';
import Image from './Image';

type Props = {
  studio: ItemType,
  index: number,
  navigateToStudio: string => void,
  transition: boolean,
};

type State = {
  attributes: {
    studioPhotos: Array<AttributeType>,
    panorama: Array<AttributeType>,
    campusMap: Array<AttributeType>,
    studioFloorplan: Array<AttributeType>,
  },
  specifications: Array<AttributeType>,
  activeTab: number,
  transition: boolean,
};

class Studio extends React.Component<Props, State> {
  state = {
    attributes: {
      studioPhotos: [],
      panorama: [],
      campusMap: [],
      studioFloorplan: [],
    },
    specifications: [],
    activeTab: 0,
    transition: this.props.transition,
  };

  componentDidMount = () => {
    this.setAttributes();
    animateMatrix();
  };

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (nextProps.transition !== prevState.transition) {
      return { transition: nextProps.transition };
    }

    return null;
  }

  componentDidUpdate = (prevProps: Props) => {
    if (prevProps.studio.id !== this.props.studio.id) {
      this.setAttributes();
      this.toggleBodyOverflow();
    }
  };

  componentWillUnmount = () => {
    this.setActiveTab(0);
  };

  setAttributes = () => {
    const { attributes } = this.props.studio;

    const studioPhotos = attributes.filter(attr => attr.name.toLowerCase().includes('room photo'));
    const panorama = attributes.filter(attr => attr.name.toLowerCase().includes('panorama'));
    const campusMap = attributes.filter(attr => attr.name.toLowerCase().includes('campus map'));
    const studioFloorplan = attributes.filter(attr => attr.name.toLowerCase().includes('studio map'));
    const specifications = attributes.filter(attr => attr.type === 'text');

    this.setState({
      attributes: {
        studioPhotos,
        panorama,
        campusMap,
        studioFloorplan,
      },
      specifications,
      activeTab: 0,
    });
  };

  toggleBodyOverflow = () => {
    // $FlowFixMe
    const { classList } = document.body;
    const customClass = 'no-specifications';

    if (!this.state.specifications.length) {
      if (!classList.contains(customClass)) {
        classList.add(customClass);
      }
    } else if (classList.contains(customClass)) {
      classList.remove(customClass);
    }
  };

  setActiveTab = (activeTab: number) => {
    localStorage.setItem('activeTab', activeTab.toString());

    this.setState({ activeTab });
  };

  showPDF = () => {
    const { studioFloorplan } = this.state.attributes;

    if (studioFloorplan.length > 0) {
      window.open(this.state.attributes.studioFloorplan[0].value);
    }
  };

  render(): React.Node {
    const { studio, index } = this.props;
    const { attributes, activeTab } = this.state;

    const activeTabAttributes = Object.values(attributes)[activeTab];
    const activeTabName = Object.keys(attributes)[activeTab];

    return (
      <React.Fragment>
        <div className={classnames(styles.studio, 'active')}>
          <div className="mobile-only">
            <h2 className={styles['studio-name']}>Studio {studio.name}</h2>
          </div>
          <div className="wrap">
            <div className={styles.title}>
              <h1>Studios</h1>
            </div>
            <div className={styles['studio-menu']}>
              <h2 className={styles['studio-name']}>Studio {studio.name}</h2>
              <StudioNav
                attributes={attributes}
                activeTabName={activeTabName}
                setActiveTab={this.setActiveTab}
                showPDF={this.showPDF}
              />
            </div>
          </div>
          <Image
            // $FlowFixMe
            images={activeTabAttributes}
            activeTabName={activeTabName}
            index={index}
            studioInternalName={studio.internalName}
            navigateToStudio={this.props.navigateToStudio}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default Studio;



// WEBPACK FOOTER //
// ./src/components/Studio/index.js